<div
  [@openCloseInput]="!ppCollapsed ? 'open' : 'closed'"
  class="formulaBuilder__input"
  [ngClass]="{ formulaBuilder__inputClosed: ppCollapsed }"
  [class.formulaBuilder__input--empty]="ppFormula.length === 0"
  >
  @if (ppFormula.length === 0) {
    <div
      class="formulaBuilder__inputPlaceholder"
      [class.formulaBuilder__inputPlaceholderCollapsed]="ppCollapsed"
      >
      @if (ppCollapsed) {
        <span>{{ ppPlaceholder }}</span>
      } @else {
        {{ 'formula_builder_placeholder' | ppTranslate }}
      }
    </div>
  }

  <div
    cdkDropList
    cdkDropListOrientation="mixed"
    class="formulaList"
    (cdkDropListDropped)="drop($event)"
    >
    @for (formulaPiece of ppFormula; track formulaPiece; let index = $index) {
      <pp-formula-piece
        class="draggableFormulaPiece"
        [ppFormulaPiece]="formulaPiece"
        [ppWorkspaceId]="ppWorkspaceId"
        [ppCanDelete]="true"
        (ppDelete)="deleteFormulaPiece(index)"
        cdkDrag
      ></pp-formula-piece>
    }
  </div>
</div>
